import { CONFIG } from '../../../core/config';
import { ViewModel } from '../../view-model';
import { HierarchyTemplate } from './hierarchy-template';
import { HierarchyTemplateGroup } from './hierarchy-template-group';

export class HierarchyTemplateTab implements ViewModel {

  public friendlyTypeNameSingular: string = 'Hierarchy Template Tab';
  public apiRoute: string = CONFIG.apiRoutes.hierarchyTemplatesTabs;

  public hierarchyTemplateTabId: string;
  public hierarchyTemplateId: string;
  public name: string;
  public sortingIndex: number;
  public hierarchyTemplate: HierarchyTemplate;
  public hierarchyTemplateGroups: HierarchyTemplateGroup[] = [];

  public json(): HierarchyTemplateTab {
    return this;
  }

  public loadFromJson(data: HierarchyTemplateTab): void {
    this.hierarchyTemplateTabId = data.hierarchyTemplateTabId;
    this.hierarchyTemplateId = data.hierarchyTemplateId;
    this.name = data.name;
    this.sortingIndex = data.sortingIndex;
    this.hierarchyTemplate = data.hierarchyTemplate;
    this.hierarchyTemplateGroups = data.hierarchyTemplateGroups;
  }

}
